import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, of, Subject } from 'rxjs';
import {
  HttpClientAdapter,
  HttpClientEvent,
  IRequestOption,
} from '../../domain/adapters/http.adapter';
import { StorageAdapter } from '../../domain/adapters/storage.adapter';
import { Result } from '../../domain/models/http-response.model';
import { environment } from '../../../environments/environment';

@Injectable()
export class ApiHttpService implements HttpClientAdapter {
  private baseUrl = environment.apiUrl;

  constructor(private http: HttpClient, private storage: StorageAdapter) {}

  private eventSubject = new Subject<HttpClientEvent>();
  event$ = this.eventSubject.asObservable();

  private getAuthToken(): string | null {
    return this.storage.getBlocking<string | null>('authToken');
  }

  private getHttpHeaders(reqHeaders: IRequestOption['headers']): HttpHeaders {
    let httpHeaders = new HttpHeaders();

    const authToken = this.getAuthToken();
    if (authToken) {
      httpHeaders = httpHeaders.set('Authorization', `Bearer ${authToken}`);
    }

    if (reqHeaders) {
      Object.keys(reqHeaders).forEach((key) => {
        httpHeaders = httpHeaders.append(key, reqHeaders[key]);
      });
    }

    // if content type is missing add default
    if (!httpHeaders.get('Content-Type')) {
      httpHeaders.append('Content-Type', 'application/json');
    }

    return httpHeaders;
  }

  request<T>({
    method,
    url,
    body,
    headers,
  }: IRequestOption): Observable<Result<T, any>> {
    // TODO: add type for error
    return this.http
      .request<T>(method, `${this.baseUrl}${url}`, {
        headers: this.getHttpHeaders(headers),
        body,
      })
      .pipe(
        map((response) => {
          return new Result<T, any>(response, null);
        }),
        catchError((error: HttpErrorResponse) => {
          if (error.status === 401) {
            this.eventSubject.next(HttpClientEvent.UNAUTHORIZED);
          }
          return of(
            new Result<T, any>(null, { ...error.error, status: error.status })
          );
        })
      );
  }
}
